import { useCanViewNovaAnalytics } from './use-can-view-nova-analytics';
import { DISABLED_SETTINGS_ADMINISTRATION } from '../components/skill-administration/types';
import { useChatOverlayContext, type ChatSettingsSection } from '../contexts/chat-overlay-context';

export function useActiveSettingsSection(section?: ChatSettingsSection): ChatSettingsSection {
  const { settingsSection: currentSection, settingsAdministration = DISABLED_SETTINGS_ADMINISTRATION } =
    useChatOverlayContext();
  const settingsSection = section ?? currentSection;
  const canViewAnalytics = useCanViewNovaAnalytics();
  const administrationUnresolved =
    settingsAdministration.status === 'loading' || settingsAdministration.status === 'error';

  if (settingsSection === 'teams' && (settingsAdministration.showTeams || administrationUnresolved)) return 'teams';
  if (settingsSection === 'admins' && (settingsAdministration.showAdmins || administrationUnresolved)) return 'admins';
  if (settingsSection === 'analytics' && canViewAnalytics) return 'analytics';
  if (settingsSection === 'skills') return 'skills';
  if (settingsSection === 'scheduled') return 'scheduled';
  return 'general';
}
